module.exports = __webpack_public_path__ + "img/logo.59e166a5.png";